/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolAccountTreeIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-account-tree"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M15.15 19.05L15.15 18.65L13.35 18.65Q12.22 18.65 11.46 17.89Q10.7 17.13 10.7 16L10.7 8L8.85 8L8.85 8.45Q8.85 9.57 8.09 10.34Q7.33 11.1 6.2 11.1L3.75 11.1Q2.63 11.1 1.86 10.34Q1.1 9.57 1.1 8.45L1.1 4.95Q1.1 3.83 1.86 3.06Q2.63 2.3 3.75 2.3L6.2 2.3Q7.33 2.3 8.09 3.06Q8.85 3.83 8.85 4.95L8.85 5.35L15.15 5.35L15.15 4.95Q15.15 3.83 15.91 3.06Q16.68 2.3 17.8 2.3L20.25 2.3Q21.38 2.3 22.14 3.06Q22.9 3.83 22.9 4.95L22.9 8.45Q22.9 9.57 22.14 10.34Q21.38 11.1 20.25 11.1L17.8 11.1Q16.68 11.1 15.91 10.34Q15.15 9.57 15.15 8.45L15.15 8L13.35 8L13.35 16Q13.35 16 13.35 16Q13.35 16 13.35 16L15.15 16L15.15 15.55Q15.15 14.43 15.91 13.66Q16.68 12.9 17.8 12.9L20.25 12.9Q21.38 12.9 22.14 13.66Q22.9 14.43 22.9 15.55L22.9 19.05Q22.9 20.18 22.14 20.94Q21.38 21.7 20.25 21.7L17.8 21.7Q16.68 21.7 15.91 20.94Q15.15 20.18 15.15 19.05Z" fill={color} />
    </svg>
  );
}
